<template>
  <input
    type="text"
    :value="color"
    data-test="graphics-colorpicker"
    data-entity="graphics-colorpicker"
  >
</template>

<script>
import EventBus from '../utils/event-bus';
import toast from '../utils/toasts';
import '../libs/spectrum';

export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      required: true,
      validator: (v) => typeof v === 'string' || v === null,
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    isMapped: {
      type: Boolean,
      default: false,
    },
    allowAlpha: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    color: {
      get() {
        return this.modelValue ?? 'fff';
      },
      set(v) {
        this.$emit('update:modelValue', v);
      },
    },
    containerClass() {
      return `tgb-spectrum${this.isMapped ? '--isMapped' : ''}`;
    },
  },
  watch: {
    color(newVal, oldVal) {
      const transparentRegex = /^(transparent|rgba\((\d+,\s*){3}0(\.\d+)?\))$/i;
      if (this.allowAlpha === false && transparentRegex.test(newVal)) {
        toast.makeToast({
          heading: 'Information',
          icon: 'info',
          hideAfter: 4000,
          stack: false,
          text: 'This element is required. Therefore, it cannot be transparent.',
          loaderBg: '#00C4DD',
          bgColor: '#2288A0',
          textColor: '#FFFFFF',
        });
        this.color = '#000';
        jQuery(this.$el).spectrum('set', this.color);
        return;
      }
      if (newVal !== oldVal) {
        jQuery(this.$el).spectrum('set', newVal);
      }
    },
    isMapped(newVal) {
      jQuery(this.$el).spectrum('destroy');
      this.loadPicker();
    },
  },
  mounted() {
    this.loadPicker();
  },
  beforeUnmount() {
    jQuery(this.$el).spectrum('destroy');
  },
  methods: {
    loadPicker() {
      const self = this;
      jQuery(this.$el).spectrum({
        color: self.color,
        preferredFormat: 'hex3',
        showInitial: true,
        showInput: true,
        showAlpha: self.allowAlpha,
        showButtons: false,
        allowEmpty: self.allowEmpty,
        showPalette: false,
        containerClassName: self.containerClass,
        move(color) {
          if (color) {
            self.color = color.toRgbString();
          } else {
            self.color = '';
          }
        },
        change(color) {
          if (color) {
            self.color = color.toRgbString();
          } else {
            self.color = '';
          }
        },
        hide(color) {
          EventBus.emit('action');
        },
      });
    },
  },
};
</script>
